import React, {useContext, useEffect} from 'react'
import {StateContext} from '../../context/GlobalState.jsx'
import {Link} from 'react-router-dom'
import {Container, Row, Col, Navbar, Nav} from "react-bootstrap";
import Search from "../Search/Search.js";
import {GetText} from '../../context/text.js';
import {useCookies} from "react-cookie";
import 'remixicon/fonts/remixicon.css';



function Header() {
    // consuming context
    let {totalItems, favoriteItems, setLang} = useContext(StateContext)
    const [cookies, setCookie] = useCookies(['lang'])

    useEffect(() => {
        if(cookies.lang){
            setLang(cookies.lang)
        }else {
            setLang("ua")
        };
    }, [cookies]) // eslint-disable-next-line


    let text = GetText();


    // render JSX
    return (
        <div>

            <div className="topInfo">
                <Container>
                    <Row className="center-text">
                        <Col>
                            <a className="nolink" title="Facebook" target="_blank"  rel="noreferrer" href="https://www.facebook.com/groups/1118740248655372"> <i className="ri-facebook-circle-fill hover ramka"></i></a>
                            <a className="nolink" title="Instagram" target="_blank"  rel="noreferrer"  href="https://www.instagram.com/zapauto_rozbor/"> <i className="ri-instagram-fill hover ramka"></i></a>
                            <a className="nolink" title="Telegram" target="_blank"  rel="noreferrer"  href="https://t.me/rozborzapauto"> <i className="ri-telegram-fill hover ramka"></i></a>
                            <a className="nolink" title="TikTok" target="_blank"  rel="noreferrer"  href="https://www.tiktok.com/@zapauto_rozborka"> <i className="ri-tiktok-fill hover ramka"></i></a>
                        </Col>
                        <Col lg={8} md={4} xs={0}>

                        </Col>

                        <Col>
                            <span onClick={() => setCookie('lang', "ua", { path: '/' })} className="hover ramka-lang" >UA</span>|
                            <span onClick={() => setCookie('lang', "ru", { path: '/' })} className="hover ramka-lang" >RU</span>|
                            <span onClick={() => setCookie('lang', "en", { path: '/' })} className="hover ramka-lang" >EN</span>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className="bottomInfo">
                <Container>
                    <Row className="center-text">
                        <Col lg={2} md={2} sm={12} xs={12}><img id="logo" title="Zapauto" alt="Zapauto" className="logo" src="https://zapauto.com.ua/backend/public/images/logo-zapauto.png" /></Col>
                        <Col lg={4} md={5} sm={12} xs={12} className="padTop"><h3>+38 (068) 822-52-52</h3><h3>+38 (068) 922-52-52</h3></Col>
                        <Col lg={6} md={5} sm={12} xs={12}>
                            <Row><Col  xs={12}><h1>{text.Header.name}</h1></Col></Row>
                            <Row ><Col  xs={12}>
                                    <Search />
                            </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className="padBottom" >
                <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
                    <Container className="nav-icons menu nav">
                        <Navbar.Brand><Link title={text.Header.menu1} to='/'>{text.Header.menu1}</Link></Navbar.Brand>
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav className="me-auto">
                                <Link title={text.Header.menu2} to='/catalog'>{text.Header.menu2}</Link>
                                <Link title={text.Header.menu3} to='/cars'>{text.Header.menu3}</Link>
                                <Link title={text.Header.menu4} to='/about'>{text.Header.menu4}</Link>
                            </Nav>
                            <Nav>
                                <ul className="nav-icons menu nav">
                                    <li>
                                        <Link title="Wishlist" to='/wishlist'>
                                            <i className="ri-heart-2-line"></i>
                                            <span className="item-count">{favoriteItems.length}</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link title="Cart" to='/cart'>
                                            <i className="ri-shopping-basket-2-line"></i>
                                            <span className="item-count">{totalItems}</span>
                                        </Link>
                                    </li>
                                </ul>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </div>



        </div>
    )
}

export default Header
